/* Store links and phone detection, shared by the shell's sticky bar and the download page. */

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.yunlen.app';
export const APP_STORE_URL = 'https://apps.apple.com/us/app/yunlen/id6751148625';

export const STORES = {
  android: {
    name: 'Google Play',
    native: 'market://details?id=com.yunlen.app',
    web: PLAY_STORE_URL,
    other: 'ios',
  },
  ios: {
    name: 'App Store',
    native: 'itms-apps://itunes.apple.com/app/id6751148625',
    web: APP_STORE_URL,
    other: 'android',
  },
};

let cached;

/** 'ios' | 'android' | null. Read once per page load; the user agent does not change. */
export function detectPlatform() {
  if (cached !== undefined) return cached;
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('android')) cached = 'android';
  else if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) cached = 'ios';
  // iPadOS reports itself as a Mac; touch support gives it away.
  else if (ua.includes('macintosh') && navigator.maxTouchPoints > 1) cached = 'ios';
  else cached = null;
  return cached;
}

/**
 * Tries the store app first and falls back to the store's web page only if
 * this page is still in front a moment later, so a web page never opens on
 * top of a store app that already launched.
 */
export function openStore(platform) {
  const store = STORES[platform];
  if (!store) return;
  let fallback = 0;
  const onHide = () => {
    if (document.visibilityState === 'hidden') window.clearTimeout(fallback);
  };
  document.addEventListener('visibilitychange', onHide, { once: true });
  fallback = window.setTimeout(() => {
    document.removeEventListener('visibilitychange', onHide);
    if (document.visibilityState === 'visible') window.location.href = store.web;
  }, 1200);
  window.location.href = store.native;
}
